import React from "react";
import { Button, Badge } from "@teals/ui-web";
import {
  StepContent,
  SuccessBanner,
  DetailSection,
  DetailSectionTitle,
  KeyDisplay,
  CopyButton,
  InfoBanner,
  InfoBannerIcon,
  WizardFooter,
  FooterActions,
} from "../styles";
import { BYO_PROVIDER_LABELS } from "../constants";
import type { DataSource } from "../../../store/api/dataSourcesApi";

interface StepBYOSuccessProps {
  createdDs: DataSource | null;
  provider: string;
  indexName: string;
  onViewDataSource: () => void;
  onViewAll: () => void;
}

const StepBYOSuccess: React.FC<StepBYOSuccessProps> = ({
  createdDs,
  provider,
  indexName,
  onViewDataSource,
  onViewAll,
}) => {
  return (
    <StepContent>
      <SuccessBanner>
        <span>{"\u2713"}</span>
        <span>External data source linked successfully</span>
      </SuccessBanner>

      <DetailSection>
        <DetailSectionTitle>Portal Reference</DetailSectionTitle>

        <div>
          <label>Data Source ID</label>
          <KeyDisplay>
            <span>{createdDs?.dataSourceId}</span>
            <CopyButton
              onClick={() =>
                navigator.clipboard.writeText(createdDs?.dataSourceId ?? "")
              }
            >
              {"\u{1F4CB}"}
            </CopyButton>
          </KeyDisplay>
        </div>

        <div>
          <label>Remote Provider</label>
          <Badge variant="info">
            {BYO_PROVIDER_LABELS[provider] || provider}
          </Badge>
        </div>

        <div>
          <label>Remote Index</label>
          <KeyDisplay>
            <span>{indexName}</span>
            <CopyButton
              onClick={() => navigator.clipboard.writeText(indexName)}
            >
              {"\u{1F4CB}"}
            </CopyButton>
          </KeyDisplay>
        </div>
      </DetailSection>

      <InfoBanner>
        <InfoBannerIcon>{"\u2139\uFE0F"}</InfoBannerIcon>
        <span>
          Records remain in your external account. Agents query this data source
          through Lumina, which proxies requests to your remote index.
        </span>
      </InfoBanner>

      <WizardFooter>
        <FooterActions>
          <Button variant="secondary" onClick={onViewAll}>
            View all integrations
          </Button>
          <Button variant="primary" onClick={onViewDataSource}>
            View Data Source
          </Button>
        </FooterActions>
      </WizardFooter>
    </StepContent>
  );
};

export default StepBYOSuccess;
